import React, { useEffect } from 'react';

import { LoadableLazy } from '@confluence/loadable';
import { UNSAFE_noExposureExp } from '@confluence/feature-experiments';
import { SpotlightTransition } from '@atlaskit/onboarding';

import { useIsSpaceGettingStartedTourEligible } from './useIsSpaceGettingStartedTourEligible';

const SpaceGettingStartedTourComponentLoadable = LoadableLazy({
	loader: async () =>
		(
			await import(
				/* webpackChunkName: "loadable-SpaceGettingStartedTourComponent" */ './SpaceGettingStartedTourComponent'
			)
		).SpaceGettingStartedTourComponent,
});

export const SpaceGettingStartedTour = () => {
	const [, fireSpaceGettingStartedTourXflowExperiment] = UNSAFE_noExposureExp(
		'cc_getting_started_tour_xflow',
	);
	const [, fireSpaceGettingStartedTourExperiment] = UNSAFE_noExposureExp('cc_getting_started_tour');
	const {
		isXflowEligibleForSpaceGettingStartedTour,
		isLandAndOtherEligibleForSpaceGettingStartedTour,
		isSpaceGettingStartedTourExperimentCohort,
	} = useIsSpaceGettingStartedTourEligible();

	useEffect(() => {
		if (isXflowEligibleForSpaceGettingStartedTour) {
			fireSpaceGettingStartedTourXflowExperiment();
		}
		if (isLandAndOtherEligibleForSpaceGettingStartedTour) {
			fireSpaceGettingStartedTourExperiment();
		}
	}, [
		isXflowEligibleForSpaceGettingStartedTour,
		isLandAndOtherEligibleForSpaceGettingStartedTour,
		fireSpaceGettingStartedTourXflowExperiment,
		fireSpaceGettingStartedTourExperiment,
	]);

	return (
		<SpotlightTransition>
			{isSpaceGettingStartedTourExperimentCohort ? (
				<SpaceGettingStartedTourComponentLoadable />
			) : null}
		</SpotlightTransition>
	);
};
